export type LumeFxResult = 0 | 1;

export enum LumeFxTimeInForce {
    DAY = 0,
    GTC = 1,
    IOC = 3,
    FOK = 4,
    GTD = 6
}
export enum LumeFxOrderType {
    Market = 1,
    Limit = 2,
    Stop = 3,
    StopLimit = 4,
    Pegged = 'P'
}

export const LumeFxOrderTypeName: Record<LumeFxOrderStatus, string> = Object.fromEntries(
    Object.entries(LumeFxOrderType).map(([key, value]) => [value, key])
) as Record<LumeFxOrderStatus, string>;

export enum LumeFxSide {
    BUY = 1,
    SELL = 2
}
export enum LumeFxOrderStatus {
    New = 0,
    PartiallyFilled = 1,
    Filled = 2,
    DoneForDay = 4,
    Amended = 5,
    Canceled = 6,
    Replaced = 8,
    PendingCancel = 'A',
    Stopped = 'C'
}

export const LumeFxOrderStatusName: Record<LumeFxOrderStatus, string> = Object.fromEntries(
    Object.entries(LumeFxOrderStatus).map(([key, value]) => [value, key])
) as Record<LumeFxOrderStatus, string>;

export type LumeFxOrderBookAction = 'subscribe' | 'unsubscribe';
export type LumeFxOrderBookUpdateType = 'snapshot' | 'reject';
export type LumeFxPriceLevel = [price: string, size: string];

export interface LumeFxRestHeaders {
    'Content-Type': string;
    authorization: string;
}

export interface LumeFxPlaceOrderRequest {
    Account: string;
    Symbol: string;
    TimeInForce: LumeFxTimeInForce;
    OrdType: LumeFxOrderType;
    Price?: string;
    OrderQty: string;
    ClOrdID?: string;
    Side: LumeFxSide;
    ExpireTime?: string;
    StopPx?: string;
    PegOffsetType?: string;
    PegPriceType?: string;
    PegDifference?: string;
    ClOrdLinkID?: string;
}

export interface LumeFxAmendOrderRequest extends LumeFxPlaceOrderRequest {
    OrigClOrdID: string;
}

export interface LumeFxPlaceOrderResponse {
    result: LumeFxResult;
    text?: string;
    Account: string;
    Symbol?: string;
    Price?: string;
    OrderQty?: string;
    ClOrdID?: string;
    Side?: LumeFxSide;
    OrderID?: string;
}

export interface LumeFxOrderQueryParams {
    clordid: string;
}

export interface LumeFxOrdersQueryParams {
    ordStatus?: string;
}

export interface LumeFxCancelOrderResponse {
    Result: LumeFxResult;
    Text?: string;
    Account?: string;
    Symbol?: string;
    ClOrdID?: string;
    OrderID?: string;
}

export interface LumeFxOrder {
    OrdStatus: LumeFxOrderStatus;
    Account: string;
    Symbol: string;
    ClOrdID: string;
    OrderID: string;
    TimeInForce: LumeFxTimeInForce;
    OrdType: LumeFxOrderType;
    Price?: string;
    OrderQty: string;
    Side: LumeFxSide;
    CumQty?: string;
    LastPx?: string;
    LastQty?: string;
    Text?: string;
}

export interface LumeFxOrderStatusResponse {
    Result: LumeFxResult;
    Data?: LumeFxOrder[];
}

export interface LumeFxOrdersResponse {
    Result: LumeFxResult;
    Data?: LumeFxOrder[];
}

export interface LumeFxCancelAllOrdersResponse {
    Result: LumeFxResult;
    Data?: LumeFxOrder[];
}

export interface LumeFxOrderBookQueryParams {
    symbol: string;
}

export interface LumeFxOrderBookSnapshotResponse {
    Result: LumeFxResult;
    Symbol: string;
    Text?: string;
    Bid?: LumeFxPriceLevel[];
    Ask?: LumeFxPriceLevel[];
}

export interface LumeFxWebSocketLogon {
    msg_type: 'logon';
    authentication: string;
}

export interface LumeFxWebSocketLogonResponse {
    msg_type: 'logon_response';
    result: LumeFxResult;
    text?: string;
}

export interface LumeFxWebSocketOrderBookRequest {
    msg_type: 'orderbook_request';
    action: LumeFxOrderBookAction;
    symbol: string;
    depth?: number;
}

export interface LumeFxWebSocketOrderBookResponse {
    msg_type: 'orderbook_response';
    result: LumeFxResult;
    symbol: string;
    text?: string;
    update_type?: LumeFxOrderBookUpdateType;
    bid?: LumeFxPriceLevel[];
    ask?: LumeFxPriceLevel[];
}

export interface LumeFxWebSocketOrderStatus {
    msg_type: 'order_status';
    result: LumeFxResult;
    text?: string;
    OrdStatus: LumeFxOrderStatus;
    Account: string;
    Symbol: string;
    ClOrdID: string;
    OrderID: string;
    TimeInForce: LumeFxTimeInForce;
    OrdType: LumeFxOrderType;
    Price?: string;
    OrderQty: string;
    Side: LumeFxSide;
    CumQty?: string;
    LastPx?: string;
    LastQty?: string;
    error?: string;
}

export interface LumeFxWebSocketError {
    msg_type: 'error';
    text?: string;
    error?: string;
}
